import {} from './biomes.js';
import { UPGRADE_MATERIALS } from './upgrade-materials.js';
/**
 * Road encounters (ADR 0093): short surprises on the roads of the world
 * zone, drawn by the server alone, gone after a few minutes. The rules that
 * read these tables live in `rules/encounters.ts`, the clock and the
 * creatures in the server's `EncounterDirector`.
 */
export const ENCOUNTER_KINDS = ['peddler', 'ambush', 'lost-chest'];
export const ENCOUNTERS = {
    peddler: { weight: 3, lifetimeMs: 5 * 60_000 },
    ambush: { weight: 4, lifetimeMs: 4 * 60_000 },
    'lost-chest': { weight: 3, lifetimeMs: 4 * 60_000 },
};
/** How often the director rolls for a new encounter in each biome a player walks. */
export const ENCOUNTER_ROLL_MS = 60_000;
/** The chance, on each roll, that a biome with a player in it gets one. */
export const ENCOUNTER_CHANCE = 0.35;
/** At most this many on the roads of the whole world at once. */
export const ENCOUNTER_MAX_ACTIVE = 3;
/** One at a time in a biome, and none again there for this long after it ends. */
export const ENCOUNTER_BIOME_REST_MS = 3 * 60_000;
/**
 * Where it lands, from the player it is drawn for: far enough to be come
 * upon down the road, near enough to be worth the walk.
 */
export const ENCOUNTER_MIN_DISTANCE = 20;
export const ENCOUNTER_MAX_DISTANCE = 50;
/** Kept off the villages: their roads are busy enough. */
export const ENCOUNTER_VILLAGE_MARGIN = 10;
/** Who hears of it as it appears, in tiles: about two screens. */
export const ENCOUNTER_HEAR_RANGE = 40;
/** How close a player stands to buy from the peddler or open the chest. */
export const ENCOUNTER_REACH = 2;
/** A rescuer is paid if still this close to the traveller when the last raider falls. */
export const AMBUSH_SHARE_RANGE = 20;
/** The raiders round the traveller. */
export const AMBUSH_RAIDERS = 3;
/** The rescued traveller thanks them, then goes on his way after this long. */
export const AMBUSH_FAREWELL_MS = 8000;
/**
 * The peddler's wares: what no village merchant sells, the biome's rare and
 * epic upgrade materials, and its alchemist's strong potion by three. Priced
 * above the merchant's rate (`peddlerPrice`), so one never buys from him to
 * sell on.
 */
function waresOf(biome) {
    return [
        { templateId: UPGRADE_MATERIALS[biome].rare.id, quantity: 1, weight: 6 },
        { templateId: `${biome}-potion`, quantity: 3, weight: 3 },
        { templateId: UPGRADE_MATERIALS[biome].epic.id, quantity: 1, weight: 1 },
    ];
}
export const PEDDLER_WARES = {
    meadow: waresOf('meadow'),
    forest: waresOf('forest'),
    swamp: waresOf('swamp'),
    desert: waresOf('desert'),
    snow: waresOf('snow'),
};
/** The peddler's price against the merchant's buy price of the same goods. */
export const PEDDLER_MARKUP = 1.5;
/** Each character buys from one peddler once. */
export const PEDDLER_LIMIT_PER_CHARACTER = 1;
/**
 * The rescue's reward, per rescuer: this many raiders' worth of experience
 * (a third of an invasion's), and the biome's rare material at their feet.
 */
export const AMBUSH_XP_RAIDERS = 4;
export const AMBUSH_RARE_MATERIAL = 1;
//# sourceMappingURL=encounters.js.map